import { notification } from 'antd';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Countries } from '../config';

type CountriesData = {
  countries: Countries;
  isLoading: boolean;
};

const getCountries = async (): Promise<Countries> =>
  import('localizations/countries.json').then((countries) => countries.default);

export const useCountriesData = (): CountriesData => {
  const [countriesData, setCountriesData] = useState<CountriesData>({
    countries: {},
    isLoading: true,
  });

  const { formatMessage } = useIntl();

  useEffect(() => {
    let isRelevant = true;

    const fetchCountries = async () => {
      try {
        const allCountries = await getCountries();

        if (isRelevant) {
          setCountriesData({ countries: allCountries, isLoading: false });
        }
      } catch (error: unknown) {
        console.error(error);

        if (isRelevant) {
          setCountriesData({ countries: {}, isLoading: false });

          notification.error({
            // A single failed chunk leaves every country control on the page
            // empty, so one shared notification is enough.
            key: 'countriesLoadFailed',
            message: formatMessage({
              id: 'countries.loadFailed',
              defaultMessage:
                'Failed to load the country list. Reload the page.',
            }),
          });
        }
      }
    };

    fetchCountries();

    return () => {
      isRelevant = false;
    };
  }, []);

  return countriesData;
};
